import React, { useEffect, useRef } from "react";
import CSSLoader from "components/cssLoader/CSSLoader";
import useHealthProfile from "hooks/useHealthProfile";
import { useHistory, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import MedicalAssistant from "components/MedicalAssistant/MedicalAssistant";
import Spacer from "components/Spacer/Spacer";
import HealthProfileQuestion from "../../HealthProfileQuestion";
import HealthProfileRadio from "../../HealthProfileRadio";
import Input from "components/inputs/Input";
import { HealthProfileALcoholUseValidationSchema } from "helpers/validationSchema";
import FormikErrorFocus from "formik-error-focus";
import SimpleHeader from "components/header/SimpleHeader";

const ALCOHOL_USAGE = ["Never", "Occasionally", "Daily", "Previously/Quit"];
const ALCOHOL_TYPE = ["Beer", "Wine", "Liquor", "Mixed Drinks"];
const FREQUENCY = ["Day", "Week", "Month", "Year"];

function AlcoholUse() {
  const formRef = useRef();
  const history = useHistory();
  const { health_id } = useParams();

  const {
    healthPayload,
    postHealthProfile,
    postingHealthProfile,
  } = useHealthProfile();

  useEffect(() => {
    if (
      healthPayload?.health_profile &&
      healthPayload?.health_profile?.alcohol_usage
    ) {
      formRef?.current?.setValues({
        alcohol_usage:
          healthPayload?.health_profile?.alcohol_usage?.drinks_alcohol ?? "",
        kind:
          healthPayload?.health_profile?.alcohol_usage?.kind_of_alcohol ?? "",
        no_of_drinks:
          healthPayload?.health_profile?.alcohol_usage?.no_of_drinks ?? "",
        frequency:
          healthPayload?.health_profile?.alcohol_usage?.frequency ?? "",
      });
    }
  }, [healthPayload]);

  function completed() {
    history.goBack();
  }

  function onSave(values) {
    let payload = {
      alcohol_usage: {
        drinks_alcohol: values?.alcohol_usage,
        kind_of_alcohol: values?.kind,
        frequency: values?.frequency,
        no_of_drinks: values?.no_of_drinks,
      },
    };
    postHealthProfile({ healthId: health_id, payload, completed });
  }
  return (
    <div className="h-screen bg-veryLightBlue">
      <Formik
        innerRef={formRef}
        onSubmit={onSave}
        initialValues={{
          alcohol_usage: "",
          kind: [],
          no_of_drinks: "",
          frequency: "",
        }}
        validationSchema={HealthProfileALcoholUseValidationSchema}
      >
        {({ values, submitCount, errors, setFieldValue, setValues }) => (
          <Form className="h-full">
            <SimpleHeader
              showBackButton
              title="Alcohol Use"
              rightActionView={
                <button
                  disabled={postingHealthProfile}
                  type={"submit"}
                  className="text-2xl font-bold text-orange"
                >
                  {postingHealthProfile ? (
                    <CSSLoader className="w-8 h-8" color="orange" />
                  ) : (
                    "Save"
                  )}
                </button>
              }
            />
            <div className="p-12 overflow-y-auto bg-white h-eliminateHeaderWithBottomTab md:h-eliminateHeader">
              <MedicalAssistant
                content={<p>Please tell us about your alcohol usage.</p>}
              />
              <Spacer height={26} />
              <HealthProfileQuestion text={"Do you drink alcohol?"} />
              <div className={`flex items-center mt-8 flex-wrap`}>
                {ALCOHOL_USAGE?.map((usage, idx) => {
                  return (
                    <div className="flex flex-1 mb-8 mr-6" key={idx}>
                      <HealthProfileRadio
                        text={usage}
                        selected={values?.alcohol_usage === usage}
                        onClick={() => {
                          if (usage === "Never") {
                            setValues({
                              alcohol_usage: usage,
                              kind: [],
                              no_of_drinks: "",
                              frequency: "",
                            });
                          } else {
                            setFieldValue("alcohol_usage", usage);
                          }
                        }}
                      />
                    </div>
                  );
                })}
              </div>
              {submitCount && errors?.alcohol_usage ? (
                <p className="mt-4 text-base font-bold text-red">
                  {errors?.alcohol_usage}
                </p>
              ) : null}
              {values?.alcohol_usage?.length &&
              values?.alcohol_usage !== "Never" ? (
                <>
                  <Spacer height={26} />
                  <HealthProfileQuestion text={"Do you drink alcohol?"} />
                  <div className={`flex items-center mt-8 flex-wrap`}>
                    {ALCOHOL_TYPE?.map((kind, idx) => {
                      return (
                        <div className="flex flex-1 mb-8 mr-6" key={idx}>
                          <HealthProfileRadio
                            text={kind}
                            selected={values?.kind?.includes(kind)}
                            onClick={() =>
                              values?.kind?.includes(kind)
                                ? setFieldValue(
                                    "kind",
                                    values?.kind?.filter((el) => el !== kind)
                                  )
                                : setFieldValue("kind", [...values?.kind, kind])
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                  {submitCount && errors?.kind ? (
                    <p className="mt-4 text-base font-bold text-red">
                      {errors?.kind}
                    </p>
                  ) : null}
                  <Spacer height={26} />
                  <Input
                    labelstyles={{
                      fontWeight: "500",
                      textOpacity: 1,
                      color: "rgba(16, 19, 71, 1)",
                    }}
                    type="number"
                    label="Number of drinks"
                    id="no_of_drinks"
                    name="no_of_drinks"
                    min="1"
                  />
                  <Spacer height={26} />
                  <HealthProfileQuestion text={"Frequency (per)"} />
                  <div className={`flex items-center mt-8 flex-wrap`}>
                    {FREQUENCY?.map((frequency, idx) => {
                      return (
                        <div className="flex flex-1 mb-8 mr-6" key={idx}>
                          <HealthProfileRadio
                            text={frequency}
                            selected={values?.frequency === frequency}
                            onClick={() =>
                              setFieldValue("frequency", frequency)
                            }
                          />
                        </div>
                      );
                    })}
                  </div>
                  {submitCount && errors?.frequency ? (
                    <p className="mt-4 text-base font-bold text-red">
                      {errors?.frequency}
                    </p>
                  ) : null}
                </>
              ) : null}
            </div>
            <FormikErrorFocus align={"bottom"} ease={"linear"} duration={500} />
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AlcoholUse;
